import { render } from "./ClassResources.vue?vue&type=template&id=b4c2a352"
import script from "./ClassResources.vue?vue&type=script&lang=js"
export * from "./ClassResources.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__